/**
 * Suspended page translations
 */

import type { TranslationDict } from '../types'

export const suspended: TranslationDict = {
  title: {
    en: 'Account Suspended',
    'zh-CN': '账号已被暂停',
    ja: 'アカウントが停止されました',
  },
  reason_label: {
    en: 'Reason',
    'zh-CN': '原因',
    ja: '理由',
  },
  temporary: {
    en: 'Your account has been temporarily suspended until {{date}}.',
    'zh-CN': '您的账号已被暂时停用，将于 {{date}} 恢复。',
    ja: 'アカウントは {{date}} まで一時停止されています。',
  },
  permanent: {
    en: 'Your account has been permanently suspended.',
    'zh-CN': '您的账号已被永久停用。',
    ja: 'アカウントは永久に停止されました。',
  },
  appeal: {
    en: 'If you believe this is a mistake, you can appeal by contacting our safety team.',
    'zh-CN': '如果您认为这是一个错误，可以联系我们的安全团队申诉。',
    ja: 'これが間違いだと思われる場合は、セーフティチームに連絡してアピールできます。',
  },
  appeal_link: {
    en: 'Contact Safety Team',
    'zh-CN': '联系安全团队',
    ja: 'セーフティチームに連絡',
  },
  sign_out: {
    en: 'Sign Out',
    'zh-CN': '退出登录',
    ja: 'ログアウト',
  },
  try_again: {
    en: 'Your suspension has expired. Try logging in again.',
    'zh-CN': '您的停用期已结束，请重新登录。',
    ja: '停止期間が終了しました。再度ログインしてください。',
  },
  loading: {
    en: 'Loading account information...',
    'zh-CN': '正在加载账号信息...',
    ja: 'アカウント情報を読み込み中...',
  },
  no_reason: {
    en: 'No reason provided',
    'zh-CN': '未提供原因',
    ja: '理由は提供されていません',
  },
}
